export default "__VITE_ASSET__CslH2T66__"